export const selectCalculateValue = state => state.calculate;
